<template>
  <div>
    <section class="section">
      <div
        v-if="playlist"
        class="container"
      >
        <div>
          <h1 class="title">
            {{ playlist.name }}
          </h1>
          <h2 class="subTitle">
            {{ "items:" }}
          </h2>
          <draggable-playlist-items @itemClick="showPlaylistItem($event)" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { onBottom } from "src/services/infinite-loading";
import DraggablePlaylistItems from "../components/DraggablePlaylistItems";

Array.prototype.head = function() {
  return this.length > 0 ? this[0] : null;
};

export default {
  components: {
    DraggablePlaylistItems
  },
  computed: {
    ...mapGetters({
      playlist: "selectedPlaylist"
    })
  },
  mounted() {
    onBottom(() => {
      this.loadMorePlaylistItems();
    });
  },
  methods: {
    getQueryTags(item) {
      return item.template_item.tags.length > 1
        ? item.template_item.tags.map(tag => tag.name)
        : item.template_item.tags.head().name;
    },
    showPlaylistItem(item) {
      if (item.song_version)
        this.$router.push({
          name: "song",
          params: { id: item.song_version.id }
        });
    },
    ...mapActions(["loadMorePlaylistItems"])
  }
};
</script>

<style lang="scss">
.subTitle {
  border-bottom: 1px solid $grey-lighter;
}
a {
  color: #4a4a4a;
}
</style>



// WEBPACK FOOTER //
// PlaylistShow.vue?34f43522